import { Injectable, inject } from '@angular/core';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DeviceSyncStatusService } from '@rocksoft/apple-sync-sdk';
import { mergeMap } from 'rxjs/operators';
import { DeviceSyncStatusApiActions, DeviceSyncStatusResolverActions } from './device-sync-status.actions';

@Injectable()
export class DeviceSyncStatusEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(DeviceSyncStatusService);

  mdmStatussesRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceSyncStatusResolverActions.syncStatusesRequested),
      mergeMap((action) =>
        safeMap(
          this.api.getDeviceSyncStatus({
            categoryId: action.categoryId ?? undefined,
          }),
          (list) => DeviceSyncStatusApiActions.syncStatusesLoaded({ statuses: list }),
          (error) => DeviceSyncStatusApiActions.syncStatusesLoadedError({ error })
        )
      )
    );
  });
}
